<script setup lang="ts">
// Apesar do nome, este widget não é do PWA: o que ele entrega é o cache-busting
// geral do site — `updateWebsite()` e `autoUpdate()`, expostos em `window` para
// o suporte da Cactus acionar. Com a saída do PWA (ENG-843) foram removidos o
// `$pwa`, o `updateServiceWorker()` e a barra de "atualizar", que já estava
// morta por `display: none !important` no CSS.
//
// Sobra um componente sem UI. Fica assim de propósito: ele segue montado pelo
// layout só para publicar as funções em `window`.
const { $critical } = useNuxtApp();

async function fetchClear(BUILD_UNIQUE_ID: any) {
  const date: any = new Date();

  try {
    return await fetch(
      '/api/clear-cache?version=' + BUILD_UNIQUE_ID + '&d=' + date * 1,
      {
        headers: {
          Pragma: 'no-cache',
          Expires: '-1',
          'X-Version-Id': BUILD_UNIQUE_ID,
          'Cache-Control': 'no-cache',
        },
      },
    );
  } catch (ex) {
    return null;
  }
}

async function autoUpdate() {
  if (isDev() || isStage()) {
    return;
  }

  let isUpdated = true;

  try {
    const response = await updateWebsite('fetchClear');

    if (response) {
      isUpdated = (await response.json()).isUpdated;
    }
  } catch (ex) {
    return;
  }

  if (!isUpdated) {
    try {
      const x = [
        fetch('/', {
          headers: {
            Pragma: 'no-cache',
            Expires: '-1',
            'Cache-Control': 'no-cache',
          },
        }),
      ];

      if (location.href !== '/') {
        x.push(
          fetch(location.href, {
            headers: {
              Pragma: 'no-cache',
              Expires: '-1',
              'Cache-Control': 'no-cache',
            },
          }),
        );
      }
      await Promise.all(x);

      await $critical.fetch({ force: true });
    } catch (ex) {
      return;
    }

    setTimeout(function () {
      // @ts-ignore
      location.reload(true);

      const current = location.href;

      location.href = current;
    }, 1);
  }
}

async function updateWebsite(stopLevel: any) {
  let BUILD_UNIQUE_ID: any = '';

  try {
    BUILD_UNIQUE_ID = document
      .getElementsByName('x-build-id')[0]!
      .getAttribute('content');
  } catch (ex) {}

  if (!BUILD_UNIQUE_ID) {
    BUILD_UNIQUE_ID = '';
  }

  if (stopLevel === 'getBuildId') {
    return BUILD_UNIQUE_ID;
  }

  /**
   * Estes sao os unicos fetchs que devem ser manuais, nao retire eles
   * os outros devem passar pelo ApiService
   */
  if (stopLevel === 'fetchClear') {
    try {
      await $critical.fetch({ force: true });
    } catch (ex) {}

    return fetchClear(BUILD_UNIQUE_ID);
  }

  if (stopLevel !== 'onlyPwa') {
    try {
      const gets = [];

      gets.push(
        fetch('/', {
          headers: {
            Pragma: 'no-cache',
            Expires: '-1',
            'X-Version-Id': BUILD_UNIQUE_ID,
            'Cache-Control': 'no-cache',
          },
        }),
      );

      if (location.href !== '/') {
        gets.push(
          fetch(location.href, {
            headers: {
              Pragma: 'no-cache',
              Expires: '-1',
              'X-Version-Id': BUILD_UNIQUE_ID,
              'Cache-Control': 'no-cache',
            },
          }),
        );
      }
      gets.push(fetchClear(BUILD_UNIQUE_ID));
      await Promise.all(gets);
    } catch (ex) {}

    try {
      if ('caches' in window) {
        const cacheKeys = await caches.keys();

        for (let i = 0; i < cacheKeys.length; i++) {
          await caches.delete(cacheKeys[i]!);
        }
      }
    } catch (ex) {}
  }

  const currentUrl = location.href;

  if (stopLevel === 'update' || stopLevel === 'onlyPwa') {
    try {
      await $critical.fetch({ force: true });
    } catch (ex) {}

    return;
  }

  setTimeout(() => {
    try {
      location.reload();
    } catch (ex) {}
    setTimeout(function () {
      location.href = currentUrl;
    }, 10);
  }, 3000);

  location.reload();
  location.href = currentUrl;
}

if (window) {
  window.cactusUpdateWebsite = updateWebsite;
  window.cactusAutoUpdate = autoUpdate;
}
</script>

<!-- Sem UI: o componente existe só para publicar `updateWebsite` e `autoUpdate`
     em `window`. O `v-if="false"` faz o Vue render um nó de comentário em vez
     de inserir um elemento de verdade no layout. -->
<template><div v-if="false" /></template>
